import React from 'react';
import {
  Grid,
  Header,
  Container,
  Menu,
  Dropdown,
  Label,
  Table,
  Icon,
} from 'semantic-ui-react';

import {FormattedMessage} from 'react-intl';
import { PRIMARY_COLOR } from '../constants';

const wordOptions = [
  {
    key: '5.000',
    text: '5.000',
    value: 5000,
  },
  {
    key: '10.000',
    text: '10.000',
    value: 10000,
  },
  {
    key: '25.000',
    text: '25.000',
    value: 25000,
  },
  {
    key: '40.000',
    text: '40.000',
    value: 40000,
  },
  {
    key: '50.000',
    text: '50.000',
    value: 50000,
  },
  {
    key: '60.000',
    text: '60.000',
    value: 60000,
  },
  {
    key: '70.000',
    text: '70.000',
    value: 70000,
  },
  {
    key: '80.000',
    text: '80.000',
    value: 80000,
  },
  {
    key: '90.000',
    text: '90.000',
    value: 90000,
  },
  {
    key: '100.000',
    text: '100.000',
    value: 100000,
  },
];

const speakerOptions = [
  {
    key: navigator.language === 'de-DE' ? 'Selber Sprechen' : 'Speak for yourself',
    text: navigator.language === 'de-DE' ? 'Selber Sprechen' : 'Speak for yourself',
    value: 0,
  },
  {
    key: navigator.language === 'de-DE' ? 'Fester Auftrag' : 'Fixed order',
    text: navigator.language === 'de-DE' ? 'Fester Auftrag' : 'Fixed order',
    value: 1,
  },
  {
    key: '5% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    text: '5% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    value: 5,
  },
  {
    key: '10% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    text: '10% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    value: 10,
  },
  {
    key: '15% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    text: '15% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    value: 15,
  },
  {
    key: '20% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    text: '20% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    value: 20,
  },
  {
    key: '25% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    text: '25% ' + (navigator.language === 'de-DE' ? 'Gewinnbeteiligung' : 'Profit sharing'),
    value: 25,
  }
];

const YES = navigator.language === 'de-DE' ? 'Ja' : 'Yes';
const NO = navigator.language === 'de-DE' ? 'Nein' : 'No';

class InteractivePrice extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      countWords: wordOptions[0].value,
      priceActiveItem: '9.99€',
      exclusiveActiveItem: true,
      speakerActiveItem: speakerOptions[0].value
    };
  }
  
  handleItemClickPrice = (e, { name }) => this.setState({ priceActiveItem: name })
  handleItemClickExclusive = (e, { name }) => this.setState({ exclusiveActiveItem: name === YES })
  handleChangeSpeaker = (e, { value }) => this.setState({ speakerActiveItem: value })
  handleChangeWords = (e, { value }) => this.setState({ countWords: value })

  render(){
    const {
      exclusiveActiveItem,
      priceActiveItem,
      speakerActiveItem,
      countWords } = this.state;

    const partAudory = exclusiveActiveItem ? 30 : 70;
    const partSpeaker = speakerActiveItem < 3 ? 0 : speakerActiveItem;
    const partAuthor = 100 - partAudory - partSpeaker;

    //const partOther = exclusiveActiveItem ? 60 : 75;
    //const partOtherAuthor = 100 - partOther - partSpeaker;

    const cashAuthor = ((partAuthor / 100) * parseFloat(priceActiveItem.split('€')[0], 10)).toFixed(2);
    //onst cashAuthorOther = ((partOtherAuthor / 100) * parseInt(priceActiveItem.split('€')[0], 10)).toFixed(2);
    return (
      <Container>
        <Header as='h2'>
          <FormattedMessage id="audory.interactivePrice.head"/>
        </Header>
        <Header as='h4'>
          <center>
            <FormattedMessage id="audory.interactivePrice.exclusive"/>
          </center>
        </Header>
        <Menu widths={2}>
          <Menu.Item
            name={YES}
            active={exclusiveActiveItem}
            onClick={this.handleItemClickExclusive}
          />
          <Menu.Item
            name={NO}
            active={!exclusiveActiveItem}
            onClick={this.handleItemClickExclusive}
          />
        </Menu>

        <Header as='h4'>
          <center>
            <FormattedMessage id="audory.interactivePrice.speakerForm"/>
          </center>
        </Header>
        <Dropdown
          value={speakerActiveItem}
          fluid
          selection
          options={speakerOptions}
          onChange={this.handleChangeSpeaker}
        />
        {
          speakerActiveItem === 1 &&
          <div style={{marginTop: 'calc(2rem - .14285714em)'}}>
            <Header as='h4'>
              <center>
                <FormattedMessage id="audory.interactivePrice.wordCount"/>
              </center>
            </Header>
            <Dropdown
              value={countWords}
              fluid
              selection
              options={wordOptions}
              onChange={this.handleChangeWords}
            />
          </div>
        }

        <Header as='h4'>
          <center><FormattedMessage id="audory.interactivePrice.price"/></center>
        </Header>
        {
          /*
<Menu widths={7}>
          <Menu.Item
            name='3‎€'
            active={parseInt(priceActiveItem.split('€')[0], 10) === 3}
            onClick={this.handleItemClickPrice}
          />
          <Menu.Item
            name='5‎€'
            active={parseInt(priceActiveItem.split('€')[0], 10) === 5}
            onClick={this.handleItemClickPrice}
          />
          <Menu.Item
            name='7‎€'
            active={parseInt(priceActiveItem.split('€')[0], 10) === 7}
            onClick={this.handleItemClickPrice}
          />
          <Menu.Item
            name='10‎€'
            active={parseInt(priceActiveItem.split('€')[0], 10) === 10}
            onClick={this.handleItemClickPrice}
          />
          <Menu.Item
            name='12€'
            active={parseInt(priceActiveItem.split('€')[0], 10) === 12}
            onClick={this.handleItemClickPrice}
          />
          <Menu.Item
            name='15‎€'
            active={parseInt(priceActiveItem.split('€')[0], 10) === 15}
            onClick={this.handleItemClickPrice}
          />
          <Menu.Item
            name='20‎€'
            active={parseInt(priceActiveItem.split('€')[0], 10) === 20}
            onClick={this.handleItemClickPrice}
          />
        </Menu>
          */
        }
        <Menu widths={2}>
          <Menu.Item
            name='4.99€'
            active={parseFloat(priceActiveItem.split('€')[0], 10) === 4.99}
            onClick={this.handleItemClickPrice}
          >4.99€</Menu.Item>
          <Menu.Item
            name='9.99€'
            active={parseFloat(priceActiveItem.split('€')[0], 10) === 9.99}
            onClick={this.handleItemClickPrice}
          >9.99€</Menu.Item>
        </Menu>
        {
          /*
            <Header as='h3'>
              <FormattedMessage id="audory.interactivePrice.onAudory"/>
            </Header>
          */
        }
        
        <Grid style={{marginTop: 'calc(2rem - .14285714em)'}}>
          <Grid.Row style={{padding: 0}}>
            <Grid.Column style={{width: partAuthor+'%', display: partAuthor === 0 ? 'none' : 'block', padding: 0}}>
              <center>
                <Header as='h5'>{partAuthor+'%'}</Header>
              </center>
            </Grid.Column>
            <Grid.Column style={{width: partSpeaker+'%', display: partSpeaker === 0 ? 'none' : 'block', padding: 0}}>
              <center>
                <Header as='h5'>{partSpeaker+'%'}</Header>
              </center>
            </Grid.Column>
            <Grid.Column style={{width: partAudory+'%', display: 'block', padding: 0}}>
              <center>
                <Header as='h5'>{partAudory+'%'}</Header>
              </center>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{padding: 0, width: '100%'}}>
            <Grid.Column style={{width: partAuthor+'%', display: partAuthor === 0 ? 'none' : 'block', height: '20px', padding: 0, backgroundColor: PRIMARY_COLOR}}>
            </Grid.Column>
            <Grid.Column style={{width: partSpeaker+'%', display: partSpeaker === 0 ? 'none' : 'block', height: '20px', padding: 0, backgroundColor: '#20B2AA'}}>
            </Grid.Column>
            <Grid.Column style={{width: partAudory+'%', height: '20px', display: 'block', padding: 0, backgroundColor: '#1f3042'}}>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={1} style={{width: '100%'}} textAlign='center'>
            <Grid.Column>
              <Label style={{backgroundColor: PRIMARY_COLOR, color: 'white'}}>
                <Icon name='pencil' /> <FormattedMessage id="audory.interactivePrice.author"/>
              </Label>
              <Label style={{backgroundColor: '#20B2AA', color: 'white'}}>
                <Icon name='microphone' /> <FormattedMessage id="audory.interactivePrice.speaker"/>
              </Label>
              <Label style={{backgroundColor: '#1f3042', color: 'white'}}>
                <Icon name='play' /> audory
              </Label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Table basic='very'>
              <Table.Body>
                <Table.Row>
                  <Table.Cell><FormattedMessage id="audory.interactivePrice.coverCreation"/></Table.Cell>
                  <Table.Cell collapsing textAlign='right'>
                    80 - 500 ‎€
                  </Table.Cell>
                </Table.Row>
                {
                  speakerActiveItem === 1 &&
                  <Table.Row>
                    <Table.Cell><FormattedMessage id="audory.interactivePrice.speakPerWord"/></Table.Cell>
                    <Table.Cell collapsing textAlign='right'>
                      {(0.07 * countWords).toFixed(2)} ‎€
                    </Table.Cell>
                  </Table.Row>
                }
                <Table.Row>
                  <Table.Cell><FormattedMessage id="audory.interactivePrice.winPerSell"/></Table.Cell>
                  <Table.Cell collapsing textAlign='right'>
                    {cashAuthor} ‎€
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Grid.Row>
        </Grid>
        {
          /*

          <Header style={{marginTop: '3em'}} as='h3'>
          <FormattedMessage id="audory.interactivePrice.onOthers"/>
        </Header>
        <Grid style={{marginTop: 'calc(2rem - .14285714em)'}}>
          <Grid.Row style={{padding: 0}}>
            <Grid.Column style={{width: partOtherAuthor+'%', display: partOtherAuthor === 0 ? 'none' : 'block', padding: 0}}>
              <center>
                <Header as='h5'>{partOtherAuthor+'%'}</Header>
              </center>
            </Grid.Column>
            <Grid.Column style={{width: partSpeaker+'%', display: partSpeaker === 0 ? 'none' : 'block', padding: 0}}>
              <center>
                <Header as='h5'>{partSpeaker+'%'}</Header>
              </center>
            </Grid.Column>
            <Grid.Column style={{width: partOther+'%', display: 'block', padding: 0}}>
              <center>
                <Header as='h5'>{partOther+'%'}</Header>
              </center>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{padding: 0}}>
            <Grid.Column style={{width: partOtherAuthor+'%', display: partOtherAuthor === 0 ? 'none' : 'block', height: '20px', padding: 0, backgroundColor: PRIMARY_COLOR}}>
            </Grid.Column>
            <Grid.Column style={{width: partSpeaker+'%', display: partSpeaker === 0 ? 'none' : 'block', height: '20px', padding: 0, backgroundColor: '#20B2AA'}}>
            </Grid.Column>
            <Grid.Column style={{width: partOther+'%', height: '20px', display: 'block', padding: 0, backgroundColor: '#FF4500'}}>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={1} style={{width: '100%', padding: 0, marginTop: '1em'}} textAlign='center'>
            <Grid.Column>
              <Label style={{backgroundColor: PRIMARY_COLOR, color: 'white'}}>
                <Icon name='pencil' /> <FormattedMessage id="audory.interactivePrice.author"/>
              </Label>
              <Label style={{backgroundColor: '#20B2AA', color: 'white'}}>
                <Icon name='microphone' /> <FormattedMessage id="audory.interactivePrice.speaker"/>
              </Label>
              <Label style={{backgroundColor: '#FF4500', color: 'white'}}>
                <Icon name='warehouse' /> <FormattedMessage id="audory.interactivePrice.otherPlatform"/>
              </Label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Table basic='very'>
              <Table.Body>
                <Table.Row>
                  <Table.Cell><FormattedMessage id="audory.interactivePrice.coverCreation"/></Table.Cell>
                  <Table.Cell collapsing textAlign='right'>
                    80 - 200 ‎€
                  </Table.Cell>
                </Table.Row>
                {
                  speakerActiveItem === 1 &&
                  <Table.Row>
                    <Table.Cell><FormattedMessage id="audory.interactivePrice.speakPerWord"/></Table.Cell>
                    <Table.Cell collapsing textAlign='right'>
                      {(0.07 * countWords).toFixed(2)} ‎€
                    </Table.Cell>
                  </Table.Row>
                }
                <Table.Row>
                  <Table.Cell><FormattedMessage id="audory.interactivePrice.winPerSell"/></Table.Cell>
                  <Table.Cell collapsing textAlign='right'>
                    {cashAuthorOther} ‎€
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Grid.Row>
        </Grid>

          */
        }
        
      </Container>
    );
  }
}


export default InteractivePrice;


// WEBPACK FOOTER //
// ./src/components/InteractivePrice.js